export const appointmentTypes = {
  getAppointmentTypes,
  getAppointmentType,
};

const appointmentTypeList = [
  {
    appointmentTypeID: 1, //IID Install
    serviceID: 0,
    Name: "Installation",
    DisplayName: "Installation",
    ESDisplayName: "Instalación",
    Image: "./src/_images/install_fff.png",
    Description: "Let our expert technicians get you back on the road.",
    ESDescription: "Deje que nuestros técnicos expertos lo ayuden a volver a la carretera.",
  },
  {
    appointmentTypeID: 2,
    serviceID: 0,
    Name: "Calibration",
    DisplayName: "Monitoring",
    ESDisplayName: "Escucha",
    Image: "./src/_images/monitoring_fff.png",
    Description:
      "Standard service appointment for your device to perform optimally.",
    ESDescription:
      "Cita de servicio estándar para que su dispositivo funcione de manera óptima.",
  },
  {
    appointmentTypeID: 3,
    serviceID: 0,
    Name: "Lock Out",
    DisplayName: "Lock Out",
    ESDisplayName: "Dejar Fuera",
    Image: "./src/_images/lock_out_fff.png",
    Description:
      "Have our service technicians help you reset the lock out mode on your device.",
    ESDescription:
      "Pida a nuestros técnicos de servicio que le ayuden a restablecer el modo de bloqueo en su dispositivo.",
  },
  // {
  //   appointmentTypeID: 4,
  //   serviceID: 0,
  //   Name: "Vehicle Switch",
  //   DisplayName: "Vehicle Switch",
  //   ESDisplayName: "Interruptor de Vehículo",
  //   Image: "./src/_images/Maintenance_fff.png",
  //   Description:
  //     "Have our service technicians move your device from one vehicle to another.",
  //   ESDescription: "Haga que nuestros técnicos de servicio muevan su dispositivo de un vehículo a otro.",
  // },
  {
    appointmentTypeID: 5,
    serviceID: 0,
    Name: "Deinstall",
    DisplayName: "Deinstall",
    ESDisplayName: "Desinstalar",
    Image: "./src/_images/Handshake_fff.png",
    Description:
      "Finish up the process with the deinstallation of your LifeSafer device.",
    ESDescription:
      "Finalice el proceso con la desinstalación de su dispositivo LifeSafer.",
  },
  {
    appointmentTypeID: 6, //PAM Install
    serviceID: 0,
    Name: "Installation",
    ESDisplayName: "Instalación",
    Image: "./src/_images/install_fff.png",
    Description: "Let our expert technicians get you back on the road.",
    ESDescription: "Deje que nuestros técnicos expertos lo ayuden a volver a la carretera.",
  },
  {
    appointmentTypeID: 7,
    serviceID: 0,
    Name: "Monitoring",
    DisplayName: "Monitoring",
    ESDisplayName: "Escucha",
    Image: "./src/_images/pam_monitoring_fff.png",
    Description:
      "Standard service appointment for your device to perform optimally.",
    ESDescription:
      "Cita de servicio estándar para que su dispositivo funcione de manera óptima.",
  },
  {
    appointmentTypeID: 8,
    serviceID: 0,
    Name: "Device Return",
    DisplayName: "Device Return",
    ESDisplayName: "Devolución del Dispositivo",
    Image: "./src/_images/Handshake_fff.png",
    Description:
      "Finish up the process with the deinstallation of your LifeSafer device.",
    ESDescription:
      "Finalice el proceso con la desinstalación de su dispositivo LifeSafer.",
  },
];

function getAppointmentTypes() {
  return appointmentTypeList;
}

function getAppointmentType(aptTypeID) {
  return appointmentTypeList.find((x) => x.appointmentTypeID === aptTypeID);
}
